import { useQuery } from '@tanstack/react-query';
import { useOkapiKy } from '@folio/stripes/core';

export default function useCategoriesAPI() {
  const okapiKy = useOkapiKy();

  const { data, isLoading } = useQuery({
    queryKey: ['categories'],
    queryFn: () => okapiKy.get('categories?limit=1000&query=cql.allRecords=1 sortby name').json(),
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });

  return {
    categories: data?.categories || [],
    isLoading,
  };
}
